import { FiHome, FiUsers, FiBriefcase, FiMessageSquare, FiUser, FiShield, FiBookOpen } from "react-icons/fi";

// `notifKey` maps a nav item to its entry in NotificationContext's
// categoryCounts — set to null for items that never show a badge.
export const NAV_ITEMS = [
  { to: "/dashboard", label: "Home", icon: FiHome, notifKey: null },
  { to: "/communities", label: "Communities", icon: FiUsers, notifKey: "communities" },
  { to: "/jobs", label: "Jobs", icon: FiBriefcase, notifKey: "jobs" },
  { to: "/messages", label: "Inbox", icon: FiMessageSquare, notifKey: "messages" },
  { to: "/courses", label: "Learning", icon: FiBookOpen, notifKey: "courses" },
  { to: "/profile", label: "Profile", icon: FiUser, notifKey: null },
];

// Rendered in their own visually-separated section (a divider + "Admin"
// label) wherever nav items appear, so it's always clear which links are
// admin-only rather than mixed in with everyone's navigation.
export const ADMIN_NAV_ITEMS = [
  { to: "/admin", label: "Admin", icon: FiShield, notifKey: "admin" },
];
